namespace Gamification.Gamification {
    export interface RaccomandazioniRow {
        UserId?: number;
        TenantId?: number;
        IdRaccomandazione?: number;
        Nome?: string;
        Messaggio?: string;
        Condizione?: string;
        CondizioneVerificata?: string;
        Bonus?: string;
    }

    export namespace RaccomandazioniRow {
        export const idProperty = 'IdRaccomandazione';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.Raccomandazioni';
        export const lookupKey = 'Gamification.Raccomandazioni';

        export function getLookup(): Q.Lookup<RaccomandazioniRow> {
            return Q.getLookup<RaccomandazioniRow>('Gamification.Raccomandazioni');
        }
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdRaccomandazione = "IdRaccomandazione",
            Nome = "Nome",
            Messaggio = "Messaggio",
            Condizione = "Condizione",
            CondizioneVerificata = "CondizioneVerificata",
            Bonus = "Bonus"
        }
    }
}
